import React, { useState } from "react";
import {
  Modal,
  Box,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
  useMediaQuery,
} from "@material-ui/core";
import { Close } from "@material-ui/icons";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import { showToast } from "../../utils/toast";
import { QRCodeCanvas } from "qrcode.react";
import QrCode from "../../assets/images/icons/qr-code.svg";
import referralProgramIcon from "../../assets/images/icons/refferalProgramIcon.svg";
import whatsappIcon from "../../assets/images/icons/whatIcon.png";
import xIcon from "../../assets/images/icons/xIcon.png";
import facebookIcon from "../../assets/images/icons/facebookIcon.png";
import gmailIcon from "../../assets/images/icons/gmailIcon.png";
import discordIcon from "../../assets/images/icons/discordIcon.png";
import outlookIcon from "../../assets/images/icons/outlookIcon.png";
import telegramIcon from "../../assets/images/icons/telegramIcon.png";

const useStyles = makeStyles(theme => ({
  modalWrapper: {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    backgroundColor: "#131313",
    width: "586px",
    // width: "55%",
    borderRadius: "12px",
    boxShadow: "0px 4px 20px rgba(0,0,0,0.5)",
    [theme.breakpoints.down("sm")]: {
      width: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "90%",
    },
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 24px",
  },
  headerTitle: {
    color: "#fff",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "100%",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  profileIcon: {
    width: 64,
    height: 64,
    borderRadius: "50%",
    [theme.breakpoints.down("xs")]: {
      width: 40,
      height: 40,
    },
  },
  pinkBorderButton: {
    color: "#fff",
    maxWidth: "142px",
    fontSize: "20px",
    borderRadius: "6px",
    border: "1px solid #FE5A97",
    textTransform: "capitalize",
    backgroundColor: "transparent",
    "&:hover": {
      backgroundColor: "#FE5A97",
    },
    [theme.breakpoints.down("sm")]: {
      maxWidth: "100px",
      fontSize: "14px",
    },
  },
  pinkButton: {
    color: "#fff",
    maxWidth: "240px",
    fontSize: "20p",
    borderRadius: "6px",
    backgroundColor: "#FE5A97",
    textWrap: "nowrap",
    "&:hover": {
      border: "1px solid #FE5A97",
      backgroundColor: "transparent",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "180px",
      fontSize: "14px",
      padding: "12px 24px",
      "&.MuiButton-root": {
        marginLeft: 0,
      },
    },
  },
  shareButtonsWithIcon: {
    width: 48,
    height: 48,
  },
  modalContent: {
    padding: "0 24px 24px",
    color: "#fff",
  },
  groupHeader: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginTop: "10px",
    marginBottom: "24px",
    paddingBottom: "24px",
    "&::after": {
      content: '""',
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: 1,
      backgroundColor: "#FFFFFF1A",
    },
    "&::before": {
      content: '"or"',
      position: "absolute",
      left: "50%",
      bottom: 0,
      transform: "translate(-50%, 50%)",
      color: "#A3A3A3",
      fontSize: 14,
      fontWeight: 500,
      lineHeight: "16px",
      backgroundColor: "#131313",
      padding: "0 8px",
      zIndex: 1,
    },
  },
  headerText: {
    margin: "0 32px 0 8px",
    flex: 1,
    maxWidth: "calc(100% - 40%)",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "60%",
    },
    [theme.breakpoints.down("xs")]: {
      maxWidth: "calc(100% - 40px)",
    },
  },
  modalActions: {
    backgroundColor: "#131313",
    padding: 0,
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      maxWidth: "96%",
    },
    [theme.breakpoints.down("xs")]: {
      width: "100%",
      maxWidth: "99%",
      marginTop: "8px",
    },
  },
  shareButtons: {
    display: "flex",
    flexWrap: "wrap",
    gap: "12px",
    marginTop: "24px",
  },
  shareButton: {
    padding: 0,
    "& .MuiButton-label": {
      display: "flex",
      flexDirection: "column",
    },
  },
  qrWrapper: {
    textAlign: "center",
    width: "180px",
    margin: "20px auto 0",
  },
  profileTitle: {
    fontSize: 18,
    fontWeight: 700,
    color: "#FFFFFF",
    lineHeight: "22px",
    textAlign: "left",
    [theme.breakpoints.down("xs")]: {
      fontSize: 14,
      lineHeight: "18px",
    },
  },
  profileTitleAccent: {
    color: "#FE5A97",
  },
  shareUrl: {
    fontSize: 16,
    color: "#A3A3A3",
    textAlign: "left",
    textDecoration: "underline",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100%",
    display: "block",
    [theme.breakpoints.down("xs")]: {
      fontSize: 12,
      maxWidth: "calc(100% - 80px)",
      backgroundColor: "#1F1F1F",
      padding: "13px 8px",
      marginRight: "12px",
    },
  },
  closeButton: {
    color: "#fff",
    padding: "8px",
  },
}));

export interface ShareData {
  url: string;
  title: string;
  text: string;
  imgUrl: string;
}

interface ShareLinkDialogProps {
  open: boolean;
  onClose: () => void;
  shareData: ShareData | null;
}

const ShareLinkDialog: React.FC<ShareLinkDialogProps> = ({
  open,
  onClose,
  shareData,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  const [showQR, setShowQR] = useState(false);

  if (!shareData) return null;
  const { url, title, text, imgUrl } = shareData;
  const profileUsernameMatch = title.match(/@([a-zA-Z0-9._-]+)/);
  const profileUsername = profileUsernameMatch
    ? `@${profileUsernameMatch[1]}`
    : "";
  const isProfileShare = Boolean(profileUsername);
  const normalizedDescription = text?.trim() ?? "";
  const normalizedNickname = profileUsername || title?.trim() || "";
  const shareMessage = [normalizedNickname, normalizedDescription]
    .filter(Boolean)
    .join("\n");
  const shareMessageWithUrl = [shareMessage, url].filter(Boolean).join("\n\n");

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(url);
      showToast("Link copied to clipboard", "success");
    } catch {
      showToast("Failed to copy link", "error");
    }
  };

  const platforms = [
    {
      name: "WhatsApp",
      image: whatsappIcon,
      link: `https://wa.me/?text=${encodeURIComponent(shareMessageWithUrl)}`,
    },
    {
      name: "Gmail",
      image: gmailIcon,
      link: `mailto:?subject=${encodeURIComponent(normalizedNickname || "Sugar Cribs profile")}&body=${encodeURIComponent(shareMessageWithUrl)}`,
    },
    {
      name: "Outlook",
      image: outlookIcon,
      link: `https://outlook.live.com/owa/?path=/mail/action/compose&subject=${encodeURIComponent(normalizedNickname || "Sugar Cribs profile")}&body=${encodeURIComponent(shareMessageWithUrl)}`,
    },
    {
      name: "Discord",
      image: discordIcon,
      link: `https://discord.com/channels/@me`,
    },
    {
      name: "X",
      image: xIcon,
      link: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareMessage)}`,
    },
    {
      name: "Telegram",
      image: telegramIcon,
      link: `https://t.me/share/url?url=${encodeURIComponent(url)}&text=${encodeURIComponent(shareMessage)}`,
    },
    {
      name: "Facebook",
      image: facebookIcon,
      link: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    },
  ];

  console.log("platforms", platforms);

  return (
    <Modal open={open} onClose={onClose}>
      <Box className={classes.modalWrapper} onClick={e => e.stopPropagation()}>
        <Box className={classes.header}>
          <Typography className={classes.headerTitle}>Share link</Typography>
          <IconButton onClick={onClose} className={classes.closeButton}>
            <Close />
          </IconButton>
        </Box>

        <DialogContent className={classes.modalContent}>
          <div className={classes.groupHeader}>
            <img
              src={imgUrl}
              alt="Share Thumbnail"
              className={classes.profileIcon}
            />
            <div className={classes.headerText}>
              <Typography className={classes.profileTitle}>
                {isProfileShare ? (
                  <>
                    Meet{" "}
                    <span className={classes.profileTitleAccent}>
                      {profileUsername}
                    </span>{" "}
                    on Sugar Cribs
                  </>
                ) : (
                  title
                )}
              </Typography>
              {!isMobile && (
                <Typography variant="body2" className={classes.shareUrl}>
                  {url}
                </Typography>
              )}
            </div>
            <DialogActions className={classes.modalActions}>
              {isMobile && (
                <Typography variant="body2" className={classes.shareUrl}>
                  {url}
                </Typography>
              )}

              <IconButton
                className={
                  classes.pinkBorderButton + " " + classes.shareButtonsWithIcon
                }
                onClick={() => setShowQR(!showQR)}
              >
                <img
                  src={QrCode}
                  alt="Scan QR Code"
                  style={{ width: 24, height: 24 }}
                  className="empty-state-icon"
                />
              </IconButton>
              <IconButton
                className={
                  classes.pinkButton + " " + classes.shareButtonsWithIcon
                }
                onClick={copyLink}
              >
                <img
                  src={referralProgramIcon}
                  alt="Copy Link"
                  style={{ width: 24, height: 24 }}
                  className="empty-state-icon"
                />
              </IconButton>
            </DialogActions>
          </div>
          <Typography
            className={classes.headerTitle}
            style={{ width: "100%", fontSize: 16 }}
          >
            Share to
          </Typography>
          <Box className={classes.shareButtons}>
            {platforms.map(p => (
              <Button
                key={p.name}
                className={classes.shareButton}
                onClick={async () => {
                  if (p.name === "Discord") {
                    try {
                      await navigator.clipboard.writeText(shareMessageWithUrl);
                      showToast("Text copied. Paste it in Discord.", "success");
                    } catch {
                      showToast("Failed to copy text for Discord", "error");
                    }
                  }
                  window.open(p.link, "_blank");
                }}
              >
                <img src={p.image} alt={p.name} width={40} height={40} />
                <span
                  style={{
                    color: "#fff",
                    marginTop: "4px",
                    textTransform: "none",
                    fontSize: 12,
                  }}
                >
                  {p.name}
                </span>
              </Button>
            ))}
          </Box>

          {showQR && (
            <Box className={classes.qrWrapper}>
              <QRCodeCanvas
                value={url}
                size={180}
                bgColor="#131313"
                fgColor="#ffffff"
              />
              <Typography
                variant="caption"
                style={{ color: "#fff", marginTop: "8px" }}
              >
                Scan to open
              </Typography>
            </Box>
          )}
        </DialogContent>
      </Box>
    </Modal>
  );
};

export default ShareLinkDialog;
